<!--
 * @Description: 新闻中心
 * @Author: zml
 * @Date: 2023-07-25 10:54:13
 * @LastEditors: zml
 * @LastEditTime: 2026-02-03 10:41:17
-->
<template>
  <div class="page">
    <div class="container news">
      <div class="items" v-for="(item,index) in newsData" :key="index">
        <div class="left" @click="$router.push({path:'/newsDetail',query:{num: item.id}})">
          <img :src="item.imgUrl" :alt="`.`" srcset />
        </div>
        <div class="right">
          <div class="content-title">
            <span
              style="cursor: pointer;"
              @click="$router.push({path:'/newsDetail',query:{num: item.id}})"
            >{{ $hs(item.title,item.enTitle,item.threeTitle) }}</span>
          </div>
          <div class="content">{{$hs(item.description,item.enDescription,item.threeDescription)||''}}</div>
          <div class="date">{{item.createdTime }}</div>
        </div>
      </div>
    </div>
    <div class="container pagination">
      <el-pagination
        background="red"
        :current-page="queryParam.pageNo"
        :page-size="queryParam.pageSize"
        :page-sizes="[10, 20, 30, 40]"
        :total="totalRows"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { QueryPage } from '@/api/news'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'newsPage',
  data() {
    return {
      totalRows: 0,
      queryParam: {
        pageNo: 1,
        pageSize: 10,
        sortField: '',
        sortOrder: '',
        keywords: ''
      },
      newsData: []
    }
  },
  props: {
    datas: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    })
  },
  created() {
    this.queryPage()
  },
  methods: {
    // 选择页码大小
    handleSizeChange(pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryPage()
    },
    // 分页
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.queryPage()
    },
    queryPage() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      QueryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            this.newsData = res.data.rows || []
            this.totalRows = res.data.totalRows

            // this.newsData.forEach(item => {
            //   let date = ''
            //   date = new Date(item.createdTime)
            //   let year = date.getFullYear()
            //   let month = date.getMonth() + 1
            //   let d = date.getDate()
            //   item.createdTime = year + '/' + month + '/' + d
            // })
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(() => {
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  min-height: calc(100vh - 271px);
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  width: 100%;
  padding: 10px 0;
}

.news {
  background: #ffffff;
  border-radius: 12px;
  margin-top: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.items {
  display: flex;
  margin-left: 30px;
  margin-bottom: 20px;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 225px;
    height: 169px;
    cursor: pointer;
    img {
      max-width: 225px;
      max-height: 169px;
    }
  }
  .right {
    flex: 1;
    font-size: 16px;
    padding: 0 20px;
    box-sizing: border-box;
    .content-title {
      width: 1139px;
      height: 69px;
      line-height: 69px;
      font-size: 22px;
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      height: 21px;
      width: 1139px;
      font-size: 18px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date {
      margin: 45px 0 0 0;
      color: #b2b2b2;
    }
  }
}

.pagination {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-top: 15px;
}

::v-deep .el-pager li {
  margin: 0 5px !important;
}
::v-deep .el-pagination .btn-next {
  margin: 0 5px !important;
}
::v-deep .el-pagination .btn-prev {
  margin: 0 5px !important;
}
</style>
